import { Injectable } from '@angular/core';
import { AppSettings } from '../../../../app.settings';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class VoicemailService {

  fileUrl = `${AppSettings.API_ENDPOINT}/${'get-topic/1'}`;
    topicUrl = `${AppSettings.API_ENDPOINT}/${'get-keywords'}`;
    postFileUrl = `${AppSettings.API_ENDPOINT}/${'audio-file-upload'}`;
    postPdfUrl = `${AppSettings.API_ENDPOINT}/${'sentiment-pdf'}`;
    postTexturl = `${AppSettings.API_ENDPOINT}/${'sentiment-text-file'}`;
    postEmailUrl = `${AppSettings.API_ENDPOINT}/${'email-upload'}`;
    postSurveyFeedback = `${AppSettings.API_ENDPOINT}/${'survey-feedback'}`;
    
    constructor(private http: HttpClient) { }
  
    getFile(){
      return this.http.get(this.fileUrl);
    }
    
    getTopic(id:any){
      return this.http.get(`${this.topicUrl}/${id}`);
    }
  
    uploadFile(data:any){
      return this.http.post(this.postFileUrl, data);
    }
  
    uploadPdf(data:any){
      return this.http.post(this.postPdfUrl, data);
    }
  
    uploadText(data:any){
      return this.http.post(this.postTexturl, data);
    }
  
    uploadEmail(data:any){
      return this.http.post(this.postEmailUrl, data);
    }
  
     
  
   UploadSurveyFeedback(data:any){
     return this.http.post(this.postSurveyFeedback,data);
   }
}
